export default [
  {
    name: '体验页',
    path: '/experience',
    component: '@/pages/experience',
  },
  {
    name: 'html预览',
    path: '/htmlPreview',
    component: '@/pages/htmlPreview',
  },
  {
    path: '/user',
    component: '../layouts/BlankLayout',
    routes: [
      {
        path: '/user',
        redirect: '/user/login',
      },
      {
        name: '登录',
        icon: 'smile',
        path: '/user/login',
        component: './user/login',
      },
      {
        component: './exception/404',
      },
    ],
  },
  {
    path: '/',
    component: '../layouts/BasicLayout',
    routes: [
      {
        path: '/',
        redirect: '/bank/story',
      },
      {
        name: '工作台',
        path: '/workbench',
        routes: [
          {
            name: '首页',
            icon: 'icon-shouye',
            path: '/workbench/dashboard',
            component: './dashboard',
            hideHeader: true,
          },
          {
            name: '流量看板',
            icon: 'icon-shouye',
            path: '/workbench/bill',
            component: './bill',
            hideHeader: true,
            hideInMenu: true,
          },
          {
            component: './dataforceRender',
          },
          
        ]
      },
      {
        name: '题库管理',
        path: '/bank',
        routes: [
          {
            name: 'AI 剧本',
            icon: 'icon-ai-juben',
            path: '/bank/story',
            component: './case/story',
            hideHeader: true,
          },
          {
            name: '案例管理',
            icon: 'icon-anliguanli',
            path: '/bank/case',
            routes: [
              {
                path: '/bank/case',
                redirect: '/bank/case/dialog',
              },
              {
                name: '素材库',
                path: '/bank/case/material',
                component: './case/material',
                // hideHeader: true,
                // hideInMenu: true,
              },
              {
                name: '案例库',
                path: '/bank/case/dialog',
                component: './case/dialog',
                hideHeader: true,
                // hideInMenu: true,
              },
            ],
          },
          {
            name: '工具库',
            icon: 'icon-gongjuku',
            path: '/bank/toolsPage',
            component: './toolsPage',
            hideHeader: true,
          },
        ]
      },


      {
        name: '使用工具', // 用于使用工具的页面,使用工具时跳转展示
        path: '/bank/toolsPage/useTools',
        component: '@/components/UseTools',
      },
      {
        name: '组卷考试',
        path: '/exam',
        routes: [{
          name: '接待室',
          icon: 'icon-jiedaishi',
          path: '/exam/admit',
          routes: [
            {
              path: '/exam/admit',
              redirect: '/exam/admit/train',
            },
            {
              name: '模拟接待',
              path: '/exam/admit/train',
              component: './admit/train',
              hideHeader: true,
            },
            {
              name: '接待记录',
              path: '/exam/admit/information/',
              component: './admit/information',
              hideHeader: true,
            },
            {
              name: '接待记录',
              path: '/exam/admit/information/:id',
              component: './admit/information',
              hideHeader: true,
              hideInMenu: true,
            },
            {
              name: '接待详情',
              path: '/exam/admit/details',
              component: './admit/details',
              hideHeader: true,
              // hideInMenu: true,
            },
          ],
        }]
      },
      {
        name: '系统设置',
        path: '/system',
        routes: [
          {
            name: '基础设置',
            icon: 'icon-jichushezhi',
            path: '/system/person',
            routes: [
              {
                name: '员工管理',
                path: '/system/person/manage',
                component: './person/manage',
                hideHeader: true,
              },
              {
                name: '用户组',
                path: '/system/person/user',
                component: './person/user',
                hideHeader: true,
              },
              {
                name: '快捷短语',
                path: '/system/person/shortcut',
                component: './person/shortcut',
                hideHeader: true,
              },
              {
                name: 'AI 导师评价方案',
                path: '/system/person/appraise',
                component: './person/appraise',
                hideHeader: true,
              },
            ],
          },
        ]
      },


      {
        component: './dataforceRender',
      },
      {
        component: './exception/404',
      },
    ],
  },
]
